import { useMemo } from 'react';

import type { Id } from '@e-socna/data-layer';

import { useReferencesContext } from '../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

import {
  filterMissionWorkflowsOfFamily,
  findMissionWorkflowFamily,
} from '../utils/mission-workflow-family.util';

// The mission workflows a mission is converted into: those of the family of
// its workflow (docs/spec/collaborative-mode-workflows.md).
export const useMissionWorkflowFamily = (missionWorkflowId: Id) => {
  const { missionWorkflows, workflowFamilies } = useReferencesContext();

  return useMemo(() => {
    const family = findMissionWorkflowFamily(
      workflowFamilies,
      missionWorkflowId,
    );

    return {
      family,
      familyMissionWorkflows: filterMissionWorkflowsOfFamily(
        missionWorkflows,
        family,
      ),
    };
  }, [missionWorkflowId, missionWorkflows, workflowFamilies]);
};
